import {useParams} from "react-router-dom";
import {ViewDocumentPanel} from "document/component/container";
import {ColectorService} from "saneamiento/service";

const ViewColectorDocumentPanel = () => {
    const {idColector} = useParams();

    const handleSetFeaturedImage = documentId => {
        return ColectorService.updateWithPatch({
            id: idColector,
            featured_image: documentId,
        });
    };

    const handleSetFeaturedDocument = documentId => {
        return ColectorService.updateWithPatch({
            id: idColector,
            featured_document: documentId,
        });
    };

    return (
        <ViewDocumentPanel
            onSetFeaturedImage={handleSetFeaturedImage}
            onSetFeaturedDocument={handleSetFeaturedDocument}
        />
    );
};

export default ViewColectorDocumentPanel;
